"use strict";

exports.__esModule = true;
var _ElementEditorVerticalToolbar = require("./ElementEditorVerticalToolbar");
Object.keys(_ElementEditorVerticalToolbar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ElementEditorVerticalToolbar[key]) return;
  exports[key] = _ElementEditorVerticalToolbar[key];
});